module.exports = __webpack_public_path__ + "img/1367.088d194b.png";